
/**
 *  props：
 * @params visible //抽屉是否可见
 */
import {
    action,
    observable,
    computed,
    toJS
} from 'mobx';
import {Keyboard} from 'tplus-components-touch'




class QuickKeyStore{
    @observable visible = false;
    @observable quickKeyList = [];
    
    showCallback = () => {}

    @action init = ({}) => {
        console.log("初始化QuickKeyStore")
        this.show();
    }

    @action show=()=>{
        const { hotKeyConfig } = window.$;
        this.quickKeyList = hotKeyConfig;
        console.log("展示QuickKeyStore")
        this.visible=true;
        Keyboard.close();
        const activeElement = document.activeElement;
        activeElement && activeElement.blur();
        $ && setTimeout(() => $.observerTrigger(), 10);
        this.showCallback();
        
    }
    @action onShow = (callback) => {
        this.showCallback = callback;
    }


    @action hide=()=>{
        this.visible=false;
        Keyboard.close();
        $ && setTimeout(() => $.observerTrigger(), 10);
    }


	@computed get ToJSHotKeyConfigList(){
		return toJS(this.quickKeyList);
	}
}
export default  new QuickKeyStore();
